module.exports = __webpack_public_path__ + "static/media/plam_mbti_loading_gif.796105e1.gif";